import React, { useState } from 'react';
import empty from '../../../../../../../assets/images/emtycac.svg';
import { RavenBadge, RavenButton, toast } from '@ravenpay/raven-bank-ui';
import complianceImage from '../../../../../../../assets/images/complianceimage.png';
import ImageFragment from '../../../../../../../components/common/ImageFragment';
import '../../styles/singlecompliance.css';
import { useNavigate } from 'react-router-dom';
import { verifyCACDocuments } from '../../../../../../../redux/cac';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_ROUTES } from '../../../../../../../routes/dashboard/overview/AllPathNames';
import RootState from '../../../../../../../redux/types';
import { icons } from '../../../../../../../assets/icons';
import ConfirmModal from '../../../../compliance/compliance-cac-verification/confirmModal';
import DateFragmentBox from '../../../../../../../components/common/DateFragmentBox';

export type Cac = {
	nin?: string;
	bvn?: string;
	BAD?: string;
	fullname?: string;
	mobileNumber?: string;
	address?: string;
	dateOfBirth?: string;
	dateAuthorized?: string;
	imageUrl?: string;
	DirectorEmail?: string;
	state?: string;
	business?: string;
	StateofResidence?: string;
	LocalGovernmentArea?: string;
	FullAddress?: string;
};

interface ComplianceCaCProps {
	nin?: string;
	bvn?: string;
	fullname?: string;
	mobileNumbe?: string;
	address?: string;
	dateOfBirth?: string;
	DirectorEmail?: string;
	dateAuthorized?: string;
	imageUrl?: string;
	business?: string;
	BAD?: string;
	state?: string;
	mobileNumber?: string;
	onRevoke: () => void;
	LocalGovernmentArea?: string;
	StateofResidence?: string;
	FullAddress?: string;
	id?: string | number;
}

const CACUpload: React.FC<ComplianceCaCProps> = ({
	nin,
	LocalGovernmentArea,
	StateofResidence,
	FullAddress,
	business,
	state,
	bvn,
	DirectorEmail,
	fullname,
	mobileNumber,
	address,
	BAD,
	dateOfBirth,
	dateAuthorized,
	imageUrl,
	onRevoke,
}) => {
	const navigate = useNavigate();
	// const { loading } = useSelector((state: RootState) => state.cac);

	const { user_merchant, user_merchant_settlement, loading } = useSelector(
		(state: RootState) => state.bankbox
	);
	const [currentIndex, setCurrentIndex] = useState(0);

	// console.log("cac", user_merchant)

	const goToNextImage = () => {
		setCurrentIndex((prev) => (prev + 1) % images.length);
	};

	const goToPrevImage = () => {
		setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
	};

	user_merchant;

	const getStatusText = (status: number) => {
		switch (status) {
			case 1:
				return 'pending';
			case 3:
				return 'verified';
			case 2:
				return 'rejected';
			default:
				return 'unknown';
		}
	};

	const getStatusClass = (status: number) => {
		switch (status) {
			case 1:
				return 'yellow';
			case 3:
				return 'green';
			case 2:
				return 'red';
			default:
				return 'default';
		}
	};

	type showModalProp = {
		status: boolean;
		create: boolean;
		export: boolean;
		view_details: boolean;
		edit_details: boolean;
	};

	const [refreshTable, setRefreshTable] = useState(false);
	const [showModal, setShowModal] = useState<showModalProp>({
		status: false,
		create: false,
		export: false,
		view_details: false,
		edit_details: false,
	});
	const [confirmationData, setConfirmationData] = useState<{
		action: 'confirm' | 'reject' | 'revoke';
		email: string;
		show: boolean;
	} | null>(null);

	const handleFinish = () => {
		setRefreshTable(!refreshTable);
		setShowModal((prev) => {
			return { ...prev, export: false, status: false };
		});
	};

	const userDetailsList = [
		{
			label: 'Business Name',
			value: user_merchant?.user?.poseidon_business_name || '---',
		},
		{
			label: 'Business Address',
			value: user_merchant?.user?.poseidon_business_address || '---',
		},
		{
			label: 'Business RC Number',
			value: user_merchant?.user?.rc_number || '---',
		},
		{
			label: 'Business Type',
			value: user_merchant?.user?.poseidon_business_type || '---',
		},
		{
			label: 'Business Status',
			value: (
				<RavenBadge
					type={getStatusClass(Number(user_merchant?.user?.cac_verified ?? 0))}
					text={getStatusText(Number(user_merchant?.user?.cac_verified ?? 0))}
				/>
			),
		},
		{
			label: 'Date Authorized',
			value: (
				<DateFragmentBox date={user_merchant?.user?.cac_verified_at || '---'} />
			),
		},
	];

	const images = [
		user_merchant?.user?.cac_doc_url,
		user_merchant?.user?.cac_status_report_url,
		user_merchant?.user?.memart_url,
	].filter(Boolean);

	// //(user_merchant?.user?.cac_doc_url);

	return (
		<>
			{!['1', '3'].includes(String(user_merchant?.user?.cac_verified)) ? (
				<div className="cac-upload-card-wrapper">
					<div>
						<h1 style={{ fontSize: '1.8rem', fontWeight: '500' }}>
							Business CAC
						</h1>
						<img src={empty} alt="Empty State" className="cac-upload-image" />
					</div>
					<div className="wrp">
						<p className="cac-upload-title">
							No CAC Document from this Merchant
						</p>
						<p className="cac-upload-text">
							Transactions made by this merchant <br /> get to show up here when
							they do
						</p>
						<RavenButton
							loading={loading}
							label="Upload Merchant's CAC"
							color="deep-green-dark"
							onClick={() =>
								navigate(ALL_ROUTES?.UPLOAD_CAC, {
									state: {
										prefillBusinessName:
											user_merchant?.user?.poseidon_business_name || '',
									},
								})
							}
						/>
					</div>
				</div>
			) : (
				<div className="nin-card border-theme">
					<div className="card-header">
						<h4 className="title">Business CAC</h4>

						{/* {user_merchant?.user?.cac_verified === '1' && (
							<div style={{ display: 'flex' }}>
								<RavenButton
									label="Verify CAC Verification"
									color="deep-green-dark"
									onClick={() =>
										setConfirmationData({
											show: true,
											action: 'confirm',
											email: user_merchant?.user?.email,
										})
									}
								/>
								<RavenButton
									label="Reject CAC Verification"
									color="deep-green-dark"
									className="reusable-btn-outline-classname-cancel"
									onClick={() =>
										setConfirmationData({
											show: true,
											action: 'reject',
											email: user_merchant?.user?.email,
										})
									}
									style={{ marginLeft: '10px' }}
								/>
							</div>
						)} */}

						{/* {user_merchant?.user?.cac_verified === '3' && (
							<RavenButton
								label="Revoke CAC Verification"
								color="deep-green-dark"
								onClick={() =>
									setConfirmationData({
										show: true,
										action: 'revoke',
										email: user_merchant?.user?.email,
									})
								}
							/>
						)} */}
					</div>

					<div className="card-body">
						<div className="image-section" style={{ position: 'relative' }}>
							<ImageFragment url={images[currentIndex]}>
								<figure className="img-box">
									<img
										src={images[currentIndex]}
										alt={`Document ${currentIndex + 1}`}
										style={{
											borderRadius: '1.2rem',
											objectFit: 'cover',
											width: '100%',
											height: '100%',
										}}
									/>
								</figure>
							</ImageFragment>

							{images.length > 1 && (
								<div
									className="image-preview__pagination"
									style={{
										position: 'absolute',
										bottom: '1rem',
										left: '50%',
										transform: 'translateX(-50%)',
										display: 'flex',
										alignItems: 'center',
										gap: '10px',
										backgroundColor: 'rgba(255,255,255,0.9)',
										padding: '4px 10px',
										borderRadius: '12px',
										fontSize: '14px',
										zIndex: 2,
									}}
								>
									<figure
										onClick={currentIndex > 0 ? goToPrevImage : undefined}
										style={{
											cursor: currentIndex > 0 ? 'pointer' : 'default',
											opacity: currentIndex > 0 ? 1 : 0.5,
											width: '24px',
											height: '24px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<span style={{ width: '100%', height: '100%' }}>
											{currentIndex > 0
												? icons.arrow_back_circular_active
												: icons.arrow_back_circular_inactive}
										</span>
									</figure>

									<span>
										<p style={{ margin: 0 }}>
											{currentIndex + 1} of {images.length}
										</p>
									</span>

									<figure
										onClick={
											currentIndex < images.length - 1
												? goToNextImage
												: undefined
										}
										style={{
											cursor:
												currentIndex < images.length - 1
													? 'pointer'
													: 'default',
											opacity: currentIndex < images.length - 1 ? 1 : 0.5,
											width: '24px',
											height: '24px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<span style={{ width: '100%', height: '100%' }}>
											{currentIndex < images.length - 1
												? icons.arrow_forward_circular
												: icons.arrow_forward_circular_inactive}
										</span>
									</figure>
								</div>
							)}
						</div>

						<div className="_contents_box">
							<div className="card-content">
								{userDetailsList.map((detail, index) => (
									<div key={index} className="contents_content_holder">
										<p className="_contents_content_head">{detail.label}</p>
										<p className="_contents_content_details">
											{detail.value || 'N/A'}
										</p>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default CACUpload;
